import React from 'react';

const RouteComponent = React.lazy(() => import('./LoginPage'));

export default {
  RouteComponent,
  path: '/login',
};
